/**
 * Where the POS apps are installed from, in one place.
 *
 * The Windows installer is served by the portal itself (from R2 — it is far
 * too large to be a static asset); the stable path never changes between
 * releases, the version does. The Android terminal is on Google Play.
 *
 * The setup guide (docs/setup-guide.html) prints the same two addresses; keep
 * them in step when either moves.
 */
export const WINDOWS_INSTALLER_URL = '/downloads/billdedo-setup.exe';
export const WINDOWS_INSTALLER_VERSION = '0.1.2';

export const ANDROID_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.scandeer.pos.terminal';
